const RightQuestionsSidebar = ({ state, dispatch }) => {
  return (
    <div>
      <div
        //*?this div is a placeholder rather than the fixed div to take 1/4 of the width
        className={` sidebar-collapse-placeholder h-questions bg- transition-all  duration-300 ease-in-out md:hidden  ${
          state.collapse ? "w-1/4 " : "w-0 "
        } `}
      ></div>
      <div
        className={` right-questions-sidebar-collapse h-questions fixed right-0 top-[128px] overflow-y-auto bg-accent px-[20px] transition-all duration-300 ease-in-out md:w-full ${
          state.collapse ? "w-1/4 translate-x-0" : " w-0 translate-x-full"
        }  `}
      >
        <div
          className={`myfixed mytoggle-fixed h-fit w-full ${
            state.collapse ? "" : "hidden"
          } `}
        >
          <div className="myquestions-container-relative h-fit w-full mt-12">
            <div className="myquestions-wrapper mytoggle-QuestionsWrapper h-fit w-full">
              <div className="myactual-questions-container h-fit  w-full">
                {state.questions.map((question, i) => (
                  <span
                    key={i}
                    className={`${
                      question.is_selected
                        ? "selected-popup-question"
                        : "myquestion"
                    }`}
                    onClick={() =>
                      dispatch({ type: "setCurrentQuestionIndex", payload: i })
                    }
                  >
                    {i + 1}
                  </span>
                ))}
              </div>

              {/* TODO: ADD RESULT CONTAINER */}
              <div
                // ref={resultContainer}
                className="result-container flex h-fit w-full flex-col items-center  gap-[16px]"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RightQuestionsSidebar;
